module.exports = __webpack_public_path__ + "static/media/show.2b5b9611.svg";